import { parseUtcTimestamp } from "../../services/dateTime";

export const EMPTY_ANALYTICS_FILTERS = {
  line: "", machineType: "", machine: "", date: "", shift: "", timeFrom: "", timeTo: "",
};

export const readAnalyticsFilters = (search) => {
  const params = new URLSearchParams(search);
  return Object.fromEntries(Object.keys(EMPTY_ANALYTICS_FILTERS).map((key) => [key, params.get(key) || ""]));
};

export const analyticsSearch = (filters) => {
  const params = new URLSearchParams();
  Object.keys(EMPTY_ANALYTICS_FILTERS).forEach((key) => {
    if (filters[key]) params.set(key, filters[key]);
  });
  const query = params.toString();
  return query ? `?${query}` : "";
};

export const changeAnalyticsFilter = (current, key, value) => ({
  ...current,
  [key]: value,
  ...(["line", "machineType"].includes(key) ? { machine: "" } : {}),
});

export const matchesAnalyticsTime = (timestamp, filters = {}) => {
  if (!filters.date && !filters.timeFrom && !filters.timeTo) return true;
  if (!timestamp) return false;
  const date = parseUtcTimestamp(timestamp);
  if (!date) return false;
  const localDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  const time = `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  if (filters.timeFrom && filters.timeTo && filters.timeFrom > filters.timeTo) {
    if (filters.date) {
      const nextDay = new Date(`${filters.date}T12:00:00`);
      nextDay.setDate(nextDay.getDate() + 1);
      const nextDate = `${nextDay.getFullYear()}-${String(nextDay.getMonth() + 1).padStart(2, "0")}-${String(nextDay.getDate()).padStart(2, "0")}`;
      return (localDate === filters.date && time >= filters.timeFrom) || (localDate === nextDate && time <= filters.timeTo);
    }
    return time >= filters.timeFrom || time <= filters.timeTo;
  }
  if (filters.date && localDate !== filters.date) return false;
  return (!filters.timeFrom || time >= filters.timeFrom) && (!filters.timeTo || time <= filters.timeTo);
};

export const hasAnalyticsTimeFilter = (filters = {}) => Boolean(filters.date || filters.timeFrom || filters.timeTo);

export const analyticsScopeFilters = (filters = {}) => ({ ...filters, date: "", timeFrom: "", timeTo: "" });

export const matchesMachine = (machine, filters = {}, plantId = "") =>
  (!plantId || machine.plant_id === plantId) &&
  (!filters.line || machine.line_id === filters.line) &&
  (!filters.machine || machine.machine_id === filters.machine) &&
  (!filters.machineType || String(machine.relation_type || machine.machine_type || "").toLowerCase() === filters.machineType.toLowerCase());

export const matchesAnalyticsBatch = (batch, filters = {}, plantId = "") => {
  const raw = batch.raw || batch;
  return (!plantId || raw.plant_id === plantId) &&
    (!filters.machine || (raw.machine_id ?? raw.machine?.machine_id ?? raw.machine) === filters.machine) &&
    (!filters.line || (raw.line_id ?? raw.line?.line_id ?? raw.line) === filters.line) &&
    (!filters.shift || (raw.shift_id ?? raw.shift?.shift_id ?? raw.shift) === filters.shift) &&
    matchesAnalyticsTime(raw.started_at || raw.created_at, filters);
};
